import mutations from './mutations';
// eslint-disable-next-line import/no-cycle
import actions from './actions';
import getters from './getters';

// import helper from '@/core/helper';

const state = {
  campaigns: [],
  campaignGroups: [],
  campaign: {},
  permissions: new Map(),
  campaignProperties: {},
  campaignStats: {},
  campaignChanges: {},
  order: {},
  orders: [],
  orderChanges: {},
  existingAdvertisers: [],
  selectedAdvertiser: {},
  contentProviderId: 0,
  contentProviderName: '',
  countries: {},
  regions: [],
  regionsMap: [],
  agencies: [],
  blacklist: {},
  currencies: [],
  linkingWords: [],
  publisherList: [],
  publisherListMap: [],
  publisherIds: [],
  selectedPublisherGroups: [],
  campaignStates: [],
  isLoading: false,
  adxAdvertisers: [],
  dealOverrides: [],
  viewType: '',
  geoLocations: [],
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
